import { FC, PropsWithChildren, useEffect, useRef, useState } from "react";

const OFFSET = 200;

const Lazy: FC<PropsWithChildren<{ onLoad?: VoidFunction }>> = ({
  children,
  onLoad,
}) => {
  const [isActive, setIsActive] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onScroll = () => {
      if (!ref.current || isActive) {
        return;
      }

      const { top, bottom } = ref.current.getBoundingClientRect();

      const isInView =
        top - OFFSET < window.scrollY + window.innerHeight &&
        bottom + OFFSET > 0;

      if (isInView) {
        setIsActive(true);
        if (onLoad) {
          onLoad();
        }
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, [isActive, onLoad]);

  return <div ref={ref}>{isActive && children}</div>;
};

export default Lazy;
